import { SminexPlugIcon } from '@shared/assets/icons';
import stylex from '@stylexjs/stylex';
import { FC, ReactNode } from 'react';
import { AddButton } from '@shared/ui/add-button';
import { styles } from './styles';

interface ICardProps {
  children?: ReactNode;
  handleAddOrganizer: () => void;
}
export const EmptyCard: FC<ICardProps> = ({ children, handleAddOrganizer }) => {
  return (
    <div {...stylex.props(styles.container)}>
      <SminexPlugIcon />
      <p>Нажмите на кнопку ниже, чтобы добавить организатора</p>
      <AddButton onClick={handleAddOrganizer}>Добавить организатора</AddButton>
      {children}
    </div>
  );
};
